import { render } from "./CompetitionDetails.vue?vue&type=template&id=3876d55f&scoped=true"
import script from "./CompetitionDetails.vue?vue&type=script&lang=js"
export * from "./CompetitionDetails.vue?vue&type=script&lang=js"

import "./CompetitionDetails.vue?vue&type=style&index=0&id=3876d55f&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-3876d55f"]])

export default __exports__